import React from 'react';
import { Box, Typography, SxProps, Theme, IconButton, Tooltip } from '@mui/material';
import { Info, OpenInNew } from '@mui/icons-material';
import { SvgIconComponent } from '@mui/icons-material';
import { FORM_STYLES } from '../../styles/formStyles';

interface OptionCardProps {
  icon: SvgIconComponent;
  iconColor: string;
  iconBgColor: string;
  title: string;
  value: boolean | null;
  onChange: (value: boolean) => void;
  sx?: SxProps<Theme>;
  showInfoWhenYes?: boolean;
  infoText?: string;
  infoLink?: string;
}

export const OptionCard: React.FC<OptionCardProps> = ({
  icon: IconComponent,
  iconColor,
  iconBgColor,
  title,
  value,
  onChange,
  sx,
  showInfoWhenYes,
  infoText,
  infoLink
}) => {
  const mergedSx = {
    ...FORM_STYLES.optionCard,
    ...(sx as any)
  };

  return (
      <Box sx={mergedSx}>
        <Box sx={{ 
          width: 64,
          height: 64,
          borderRadius: '50%', 
          backgroundColor: iconBgColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2
        }}>
          <IconComponent sx={{ fontSize: 32, color: iconColor }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
          <Typography variant="body1" fontWeight="600" sx={{ textAlign: 'center' }}>
            {title}
          </Typography>
          {showInfoWhenYes && value === true && (
            <Tooltip 
              title={infoText || "Mer information"} 
              placement="top"
              arrow
            >
              <IconButton 
                size="small"
                onClick={() => infoLink && window.open(infoLink, '_blank')}
                sx={{ 
                  ml: 1,
                  width: 20, 
                  height: 20,
                  color: '#6B7280',
                  '&:hover': {
                    color: '#4B5563',
                    backgroundColor: 'rgba(107, 114, 128, 0.1)'
                  }
                }}
              >
                <OpenInNew sx={{ fontSize: 14 }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box 
            onClick={() => onChange(true)}
            sx={{ 
              ...FORM_STYLES.optionButton,
              backgroundColor: value === true ? '#62B8E9' : '#E8E8E8',
              color: value === true ? 'white' : '#6C6C6C',
              '&:hover': {
                backgroundColor: value === true ? '#4A9FD1' : '#D0D0D0',
              }
            }}
          >
            Ja
          </Box>
          <Box 
            onClick={() => onChange(false)}
            sx={{ 
              ...FORM_STYLES.optionButton,
              backgroundColor: value === false ? '#62B8E9' : '#E8E8E8',
              color: value === false ? 'white' : '#6C6C6C',
              '&:hover': {
                backgroundColor: value === false ? '#4A9FD1' : '#D0D0D0',
              }
            }}
          >
            Nej
          </Box>
        </Box>
      </Box>
  );
}; 